import bluebird from 'utils/bluebird';

export const GET_LOGFILE_BASE = 'PLAN_INTEGRATION_LOGS_GET_LOGFILE';
export const GET_LOGFILE_START = `${GET_LOGFILE_BASE}_START`;
export const GET_LOGFILE_SUCCESS = `${GET_LOGFILE_BASE}_SUCCESS`;
export const GET_LOGFILE_FAIL = `${GET_LOGFILE_BASE}_FAIL`;

export function getLogFile(opts) {
  const { logId, params } = opts;

  return dispatch => {
    dispatch({
      type: GET_LOGFILE_START,
      payload: {
        logId,
      },
    });

    return fetch(`/rest/integrations/logs/${logId}`, {
      credentials: 'same-origin',
      headers: {
        Accept: 'text/plain',
        'Content-Type': 'text/plain',
      },
      params,
    })
      .then(resp =>
        bluebird.props({
          resp,
          text: resp.text(),
        }),
      )
      .then(({ resp, text }) => {
        // error status code
        if (!resp.ok) {
          const err = new Error(resp.statusText);
          throw err;
        }

        dispatch({
          type: GET_LOGFILE_SUCCESS,
          payload: {
            logId,
            text,
          },
        });

        return text;
      })
      .catch(err => {
        dispatch({
          type: GET_LOGFILE_FAIL,
          payload: {
            logId,
            error: err,
          },
        });

        throw err;
      });
  };
}
